import React from "react";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import MtechSpot_admissionEle from "./MtechSpot_admissionEle";

function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Admission" />
            <MtechSpot_admissionEle />
        </>
    );
}

export default Main;
